import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "leftArrow", "rightArrow", "upArrow", "downArrow"]
  static values = {
    scrollAmount: { type: Number, default: 300 },
    direction: { type: String, default: "horizontal" } // "horizontal" or "vertical"
  }

  connect() {
    // Check arrow visibility on initial load
    if (this.directionValue === "vertical" && this.hasContainerTarget) {
      this.updateVerticalArrowVisibility()
      // Listen for scroll events to update arrow visibility
      this.containerTarget.addEventListener('scroll', () => this.updateVerticalArrowVisibility())
    }
  }

  disconnect() {
    if (this.hasContainerTarget) {
      this.containerTarget.removeEventListener('scroll', () => this.updateVerticalArrowVisibility())
    }
  }

  scrollLeft() {
    this.containerTarget.scrollBy({
      left: -this.scrollAmountValue,
      behavior: "smooth"
    })
  }

  scrollRight() {
    this.containerTarget.scrollBy({
      left: this.scrollAmountValue,
      behavior: "smooth"
    })
  }

  scrollUp() {
    this.containerTarget.scrollBy({
      top: -this.scrollAmountValue,
      behavior: "smooth"
    })
    // Update arrow visibility after scroll animation
    setTimeout(() => this.updateVerticalArrowVisibility(), 300)
  }

  scrollDown() {
    this.containerTarget.scrollBy({
      top: this.scrollAmountValue,
      behavior: "smooth"
    })
    // Update arrow visibility after scroll animation
    setTimeout(() => this.updateVerticalArrowVisibility(), 300)
  }

  updateVerticalArrowVisibility() {
    if (!this.hasUpArrowTarget || !this.hasDownArrowTarget) return

    const container = this.containerTarget
    const scrollTop = container.scrollTop
    const scrollHeight = container.scrollHeight
    const clientHeight = container.clientHeight
    const carousel = this.element

    // Hide up arrow if at the top (with small threshold for precision)
    if (scrollTop <= 1) {
      this.upArrowTarget.style.opacity = '0'
      this.upArrowTarget.style.pointerEvents = 'none'
      carousel.classList.add('at-top')
    } else {
      this.upArrowTarget.style.opacity = '1'
      this.upArrowTarget.style.pointerEvents = 'auto'
      carousel.classList.remove('at-top')
    }

    // Hide down arrow if at the bottom (with small threshold for precision)
    if (scrollTop + clientHeight >= scrollHeight - 1) {
      this.downArrowTarget.style.opacity = '0'
      this.downArrowTarget.style.pointerEvents = 'none'
      carousel.classList.add('at-bottom')
    } else {
      this.downArrowTarget.style.opacity = '1'
      this.downArrowTarget.style.pointerEvents = 'auto'
      carousel.classList.remove('at-bottom')
    }
  }
}
